import gql from 'graphql-tag';

export const CREATE_PROPOSAL_PRODUCT = gql`
  mutation ($input: CreateProposalProductInput!) {
    createProposalProduct(input: $input) {
      proposalProductId
    }
  }
`;
